import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import Modal from '../../../components/Modal';
import HesSpinner from '../../../components/loadingOverlay/hesSpinner';
import CustomToast from '../../../components/Toast';

const ImportXmlModal = ({
  isOpen,
  importFile,
  isImportWaiting,
  importLoadingProgress,
  handleImportFileChange,
  handleUploadImportXml,
  onClose
}) => {
  return (
    <Modal
      contentWidth="700px"
      isOpen={isOpen}
      titleName={'Import Question Set'}
      onClose={onClose}>
      {!isImportWaiting ? (
        <>
          <p>Select an XML Question Set file.</p>
          <div className="upload_xml">
            <div className="row mb-3">
              <div className="col-12">
                <div
                  className="custom-upload position-relative d-flex flex-column justify-content-center align-items-center p-5 text-center"
                  onDragOver={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    e.dataTransfer.dropEffect = 'copy';
                  }}
                  onDrop={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (e.dataTransfer.files.length > 1) {
                      CustomToast('Only 1 file can be uploaded at a time.', 'warning');
                      return;
                    }
                    if (e.dataTransfer.files.length > 0)
                      handleImportFileChange({ preventDefault: () => {}, target: { files: e.dataTransfer.files } });
                  }}>
                  <input
                    onChange={handleImportFileChange}
                    className="form-control position-absolute w-100 h-100 top-0 start-0"
                    type="file"
                    accept=".xml"
                  />
                  <span className="d-block mb-2">
                    <FontAwesomeIcon icon={faUpload} />
                  </span>
                  <p className="mb-0">
                    <strong>Click to upload</strong> or Drag and drop file
                  </p>
                  {importFile && (
                    <div className="mt-3">
                      <p>{importFile.name}</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="d-flex justify-content-center align-items-center h-40">
          <HesSpinner />
          <span className="ms-3">{importLoadingProgress === 'Importing' ? 'Importing...' : `${importLoadingProgress} Uploaded...`}</span>
        </div>
      )}
      <div className="d-flex justify-content-end gap-3 pt-2">
        <button
          className="btn btn-castleGray print-btn"
          onClick={onClose}>
          Cancel
        </button>
        <button
          className="btn btn-castleRed print-btn"
          onClick={handleUploadImportXml}
          disabled={isImportWaiting || !importFile}>
          Import
        </button>
      </div>
    </Modal>
  );
};

ImportXmlModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  importFile: PropTypes.object,
  isImportWaiting: PropTypes.bool.isRequired,
  importLoadingProgress: PropTypes.string.isRequired,
  handleImportFileChange: PropTypes.func.isRequired,
  handleUploadImportXml: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};

export default ImportXmlModal;
